import styled from '@emotion/styled'
import { Box } from '@mui/material'
import { colors } from '@resiliatech/birdsong'

export const EmptyStateContainer = styled(Box)`
  align-items: center;
  border: 1px solid ${colors.text.disabled};
  display: flex;
  height: 100%;
  padding: 16px;
  margin-top: 16px;
  width: 100%;
`
